/* global UIkit */
/* global MediaMetadata */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */

// const API_RADIO_STAT = "https://radio.olsztyn/api/oZeta/stat";
window.cookiebotEnabled = $('body').data('cookiebotenabled');

const API_RADIO_STAT = document.location.origin + "/api/oZeta/stat";
const API_JINGLE = document.location.origin + "/api/player/get_jingle";
const API_RADIO_SETTINGS = document.location.origin + "/api/oZeta/settings";
const API_RADIO_PREF = document.location.origin + "/api/oZeta/preferences";
const TEXT_DEFAULT_TITLE = "PION I POZIOM!";
const TEXT_DEFAULT_SUBTITLE = "Radio Nowy Świat";
const TEXT_MUTE_INFO = "Player jest wyciszony";
const IMG_COVER_DEFAULT = "assets/images/cover-default.png";
let SRC_PREADVERT_AUDIO = document.location.origin + "/userfiles/zamach_PRZED.wav";
let SRC_POSTADVERT_AUDIO = document.location.origin + "/userfiles/zamach_PO.wav";
let GTM_EVENT_TO = 10000;

let AFTER_PODCAST_ACTION = '';

const MD5 = function (d) {
    const r = M(V(Y(X(d), 8 * d.length)));
    return r.toLowerCase();
};

function M(d) {
    for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++) _ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _);
    return f;
}

function X(d) {
    for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++) _[m] = 0;
    for (m = 0; m < 8 * d.length; m += 8) _[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32;
    return _;
}

function V(d) {
    for (var _ = "", m = 0; m < 32 * d.length; m += 8) _ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
    return _;
}

function Y(d, _) {
    d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _;
    for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) {
        const h = m;
        const t = f;
        const g = r;
        const e = i;
        f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e);
    }
    return Array(m, f, r, i);
}

function md5_cmn(d, _, m, f, r, i) {
    return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m);
}

function md5_ff(d, _, m, f, r, i, n) {
    return md5_cmn(_ & m | ~_ & f, d, _, r, i, n);
}

function md5_gg(d, _, m, f, r, i, n) {
    return md5_cmn(_ & f | m & ~f, d, _, r, i, n);
}

function md5_hh(d, _, m, f, r, i, n) {
    return md5_cmn(_ ^ m ^ f, d, _, r, i, n);
}

function md5_ii(d, _, m, f, r, i, n) {
    return md5_cmn(m ^ (_ | ~f), d, _, r, i, n);
}

function safe_add(d, _) {
    const m = (65535 & d) + (65535 & _);
    return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m;
}

function bit_rol(d, _) {
    return d << _ | d >>> 32 - _;
}

const vis = (function () {
    var stateKey, eventKey, keys = {
        hidden: "visibilitychange",
        webkitHidden: "webkitvisibilitychange",
        mozHidden: "mozvisibilitychange",
        msHidden: "msvisibilitychange"
    };
    for (stateKey in keys) {
        if (stateKey in document) {
            eventKey = keys[stateKey];
            break;
        }
    }
    return function (c) {
        if (c) document.addEventListener(eventKey, c);
        return !document[stateKey];
    }
})();

/**
 * helper - multiEvent
 * @param {*} element
 * @param {*} eventNames
 * @param {*} listener
 */
function addListenerMulti(element, eventNames, listener) {
    const events = eventNames.split(" ");
    for (let i = 0, iLen = events.length; i < iLen; i += 1) {
        element.addEventListener(events[i], listener, false);
    }
}

/**
 * helper - formatSeconds
 * @param {*} seconds
 * @returns
 */
function formatTime(seconds) {
    if (Number.isNaN(seconds)) return "";
    let minutes = Math.floor(seconds / 60);
    minutes = (minutes >= 10) ? minutes : `0${minutes}`;
    seconds = Math.floor(seconds % 60);
    seconds = (seconds >= 10) ? seconds : `0${seconds}`;
    return `${minutes}:${seconds}`;
}

/**
 * helper - get localStorage val
 * @param {*} item
 * @param {*} defaultVal
 * @returns
 */
function getLSvalue(item, defaultVal) {
    if (typeof (Storage) !== "undefined") {
        if (localStorage.getItem(`rnsStorage_${item}`) !== null) {
            return localStorage.getItem(`rnsStorage_${item}`);
        }
        return defaultVal;
    }
    return defaultVal;
}

/**
 * helper - set localStorage val
 * @param {*} item
 * @param {*} value
 */
function saveLSvalue(item, value) {
    if (typeof (Storage) !== "undefined") {
        localStorage.setItem(`rnsStorage_${item}`, value);
    }
}

/**
 * helper - input range value ratio
 * @param {*} value
 * @param {*} min
 * @param {*} max
 * @returns
 */

function valueTotalRatio(value, min, max) {
    return ((value - min) / (max - min)).toFixed(2);
}

/**
 * helper - input range gradient
 * @param {*} ratio
 * @param {*} leftColor
 * @param {*} rightColor
 * @returns
 */
function getLinearGradientCSS(ratio, leftColor, rightColor) {
    return [
        "-webkit-gradient(",
        "linear, ",
        "left top, ",
        "right top, ",
        `color-stop(${ratio}, ${leftColor}), `,
        `color-stop(${ratio}, ${rightColor})`,
        ")",
    ].join("");
}

function getElementSize(container) {
    container.style.display = "";
    const width = container.clientWidth;
    const height = container.clientHeight;
    container.style.display = "none";
    return {width, height};
}

/**
 * helper - input range handler
 * @param {*} rangeEl
 */
function updateRangeEl(rangeEl) {
    const ratio = valueTotalRatio(rangeEl.value, rangeEl.min, rangeEl.max);
    rangeEl.style.backgroundImage = getLinearGradientCSS(ratio, "#fff", "#ff9c97");

    $vConrol = $('#neoplayer-volume-control');
    $vConrol.removeClass('rns-low-volume rns-mid-volume rns-high-volume');

    if (rangeEl.value <= 0) {
        $vConrol.find('.neoplayer-volume-toggl-muted').show();
        $vConrol.find('.neoplayer-volume-toggl').hide();
    } else {
        $vConrol.find('.neoplayer-volume-toggl-muted').hide();
        $vConrol.find('.neoplayer-volume-toggl').show();
    }

    if (rangeEl.value > 0 && rangeEl.value < 0.33) {
        $vConrol.addClass('rns-low-volume');
    }

    if (rangeEl.value >= 0.33 && rangeEl.value < 0.66) {
        $vConrol.addClass('rns-mid-volume');
    }

    if (rangeEl.value >= 0.66) {
        $vConrol.addClass('rns-high-volume');
    }
}


(function (window) {
    function neoPlayer() {
        const npObj = {};
        npObj.defaultStream = "";
        npObj.subPlayer = null;
        npObj.isStatic = false;
        npObj.staticArray = [];
        npObj.currentSrc = null;
        npObj.currentStatic = false;
        npObj.mainStatic = false;
        npObj.cachedThumbs = [];
        npObj.isDemoPodcast = false;
        npObj.trackBarIsSeeking = false;
        npObj.trackBarIsSeekingPaused = true;
        npObj.jingleActive = false;
        npObj.firstPlay = true;
        npObj.canPlayJingle = true;
        npObj.seekAfterPlay = false;
        npObj.lastStreamSrc = '';
        npObj.metadata = {
            title: "",
            subTitle: "",
            duration: 0,
            imageSrc: "",
        };
        npObj.audio = new Audio();
        npObj.updateInterval = null;
        npObj.adContainer = null;
        npObj.adDisplayContainer = null;
        npObj.adsLoader = null;
        npObj.adsReloadCount = 0;
        npObj.adsManager = null;
        npObj.videoElement = null;
        npObj.adTagUrl = '';
        npObj.usingUser = null;
        npObj.sourceSum = null;
        npObj.gtmEvent = null;
        npObj.currentSourceGtmSend = false;
        npObj.consent = false;

        npObj.initializeIMA = function (adTagUrl = "") {
            npObj.adTagUrl = adTagUrl;
            if (!adTagUrl) return;
            if (typeof google == 'undefined' || typeof google.ima == 'undefined') {
                console.error('IMA SDK not loaded');
                return;
            }
            npObj.videoElement = document.getElementById('rns-ads-video-element');
            npObj.adContainer = document.getElementById('rns-ads-container');
            npObj.adDisplayContainer = new google.ima.AdDisplayContainer(npObj.adContainer, npObj.videoElement);
        }

        npObj.loadAds = function () {
            if (!npObj.adTagUrl) {
                npObj.adsEnd();
                return;
            }
            if(window.cookiebotEnabled) {
                npObj.applyConsent();
            }
            npObj.adDisplayContainer.initialize();
            npObj.stop();

            npObj.adsLoader = new google.ima.AdsLoader(npObj.adDisplayContainer);
            npObj.adsLoader.addEventListener(
                google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
                npObj.onAdsManagerLoaded,
                false);
            npObj.adsLoader.addEventListener(
                google.ima.AdErrorEvent.Type.AD_ERROR,
                npObj.onAdError,
                false);

            const adsRequest = new google.ima.AdsRequest();
            adsRequest.adTagUrl = npObj.adTagUrl;

            // Pass the request to the adsLoader to request ads
            npObj.adsLoader.requestAds(adsRequest);
        }

        npObj.onAdsManagerLoaded = function (adsManagerLoadedEvent) {
            const adsRenderingSettings = new google.ima.AdsRenderingSettings();
            adsRenderingSettings.uiElements = [];
            npObj.adsManager = adsManagerLoadedEvent.getAdsManager(npObj.videoElement, adsRenderingSettings);

            npObj.adsManager.addEventListener(
                google.ima.AdErrorEvent.Type.AD_ERROR,
                npObj.onAdError);
            npObj.adsManager.addEventListener(
                google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
                npObj.onContentPauseRequested);
            npObj.adsManager.addEventListener(
                google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
                npObj.onContentResumeRequested);
            npObj.adsManager.addEventListener(
                google.ima.AdEvent.Type.STARTED,
                npObj.onAdEvent);
            npObj.adsManager.addEventListener(
                google.ima.AdEvent.Type.PAUSED,
                npObj.onAdEvent);
            npObj.adsManager.addEventListener(
                google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
                npObj.onAdEvent);

            const videoContainer = document.getElementsByClassName('rns-ads-video')[0];
            const {width, height} = getElementSize(videoContainer);
            try {
                npObj.adsManager.init(width, height, google.ima.ViewMode.NORMAL);
                npObj.adsManager.start();
            } catch (adError) {
                npObj.adsEnd();
            }
        }

        npObj.onAdEvent = function (adEvent) {
            const ad = adEvent.getAd();
            switch (adEvent.type) {
                case google.ima.AdEvent.Type.LOADED:
                    if (!ad.isLinear()) {
                        npObj.adsEnd();
                    }
                    break;
                case google.ima.AdEvent.Type.PAUSED:
                    npObj.adsManager.resume();
                    break;
                case google.ima.AdEvent.Type.STARTED:
                    const type = ad.getContentType();
                    if (type === 'video/mp4') {
                        npObj.videoAdsStart();
                    }
                    break;
                case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                    npObj.adsEnd();
                    break;
            }
        }

        npObj.onContentPauseRequested = function () {
            npObj.stop();
        }

        npObj.onContentResumeRequested = function () {
            npObj.adsEnd();
        }

        npObj.onAdError = function (adErrorEvent) {
            // Handle the error logging.
            const error = adErrorEvent.getError();
            if (npObj.adsLoader) {
                npObj.adsLoader.contentComplete();
            }
            if (npObj.adsManager) {
                npObj.adsManager.destroy();
            }
            if (npObj.adsLoader && error.data.errorCode == 1009) {
                if(npObj.adsReloadCount > 3) {
                    npObj.adsReloadCount = 0
                    npObj.adsEnd();
                } else {
                    npObj.adsReloadCount++;
                    npObj.loadAds();
                }
            } else {
                npObj.adsEnd();
            }
        }

        npObj.videoAdsStart = function () {
            const videoContainer = document.getElementsByClassName('rns-ads-video')[0];
            const videoOverlay = document.getElementsByClassName('rns-ads-overlay')[0];
            videoOverlay.style.display = '';
            videoContainer.style.display = '';
        }

        npObj.adsEnd = function () {
            const videoContainer = document.getElementsByClassName('rns-ads-video')[0];
            const videoOverlay = document.getElementsByClassName('rns-ads-overlay')[0];
            videoOverlay.style.display = 'none';
            videoContainer.style.display = 'none';
            npObj.jingleActive = false;
            npObj.playAudio();
        }

        npObj.updateUsingUser = function (userId) {
            npObj.usingUser = userId;
        }

        npObj.updateAdTagUrl = function (adTagUrl) {
            npObj.adTagUrl = adTagUrl;
        }

        npObj.updateConsent = function(consent) {
            npObj.consent = consent;
        }

        npObj.applyConsent = function () {
            let IMAadTagUrl = npObj.adTagUrl;

            if(typeof IMAadTagUrl == 'undefined') return;

            const regex = /(npa\=0|npa=1)/gm;
            if(npObj.consent) {
                if(IMAadTagUrl.includes('npa=')) {
                    IMAadTagUrl = IMAadTagUrl.replace(regex, 'npa=0');
                } else {
                    IMAadTagUrl = IMAadTagUrl + '&npa=0';
                }
            } else {
                if(IMAadTagUrl.includes('npa=')) {
                    IMAadTagUrl = IMAadTagUrl.replace(regex, 'npa=1');
                } else {
                    IMAadTagUrl = IMAadTagUrl + '&npa=1';
                }
            }
            npObj.updateAdTagUrl(IMAadTagUrl);
        }

        /**
         * creates neolpayer object and build html dom
         * domElement: ? string - id of parent node
         * playStopBtn: ? bool - show playStopBtn
         * volumeBtn: ? bool - show volume range slider
         * streamList: ? array - array of available stream
         *      title: ? string - name of stream
         *      bitrate: ? int - value of bitrate
         *      src: ? string - url of stream
         * @param {*} attributes
         */
        //  $.get(API_RADIO_SETTINGS + "?setting=preadevrt_file_url&tsapi=" + Date.now(), function (d) { SRC_PREADVERT_AUDIO = d; });
        // $.get(API_RADIO_SETTINGS + "?setting=postadevrt_file_url&tsapi=" + Date.now(), function (d) { SRC_POSTADVERT_AUDIO = d; });
        npObj.updateUsettings = function () {
            // $.get(API_RADIO_PREF + "?pref=afpa&tsapi=" + Date.now(), function (d) { AFTER_PODCAST_ACTION = d; });
            AFTER_PODCAST_ACTION = 'NEXT_EPISODE_ACTION';

        };
        npObj.create = function (attributes = {
            domElement: "player", playStopBtn: true, volumeBtn: true, streamList: [],
        }) {
            npObj.updateUsettings();
            setInterval(() => {
                if (vis()) {
                    // npObj.updateUsettings();
                }
            }, 60 * 1000);
            const element = document.getElementById(attributes.domElement);
            let htmlBuild = "";
            htmlBuild += "<div class=\"neoplayer-wrapper\">";
            htmlBuild += "<div class=\"neoplayer-info\"><div class=\"rns-live-stream-box\"><div id=\"neoplayer-open-dropdown\" class=\"neoplayer-open-dropdown\"><div id=\"rns-stream\"><img class=\"rns-live-stream-box__img\" src=\"assets/icons/live.svg\" width=\"30\" height=\"30\" uk-svg></div><div id=\"rns-live\"><img class=\"rns-live-stream-box__img\" src=\"assets/icons/podcast.svg\" width=\"30\" height=\"30\" uk-svg></div><div class=\"neo-player-arrow-info\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.2\" height=\"6.523\" viewBox=\"0 0 11.2 6.523\"><defs><style>.a{fill:#fff;stroke:#fff;stroke-width:0.2px;}</style></defs><path class=\"a\" d=\"M5.5,103.411a.768.768,0,0,1-.545-.225l-4.73-4.73a.77.77,0,1,1,1.089-1.089L5.5,101.551l4.185-4.185a.77.77,0,0,1,1.089,1.089l-4.73,4.73A.768.768,0,0,1,5.5,103.411Z\" transform=\"translate(0.099 -96.988)\"/></svg></div></div>";
            htmlBuild += "<div id=\"rns-stream-control\" class=\"rns-stream-control\">";
            if (attributes.streamList.length > 0) {
                // console.log(attributes.streamList);
                for (let i = 0; i < attributes.streamList.length; i += 1) {
                    const el = attributes.streamList[i];
                    htmlBuild += "<div class=\"rns-stream-tile\"><div class=\"rns-stream-info-box\"> <img class=\"rns-live-stream-img\" src=\"assets/icons/live.svg\" width=\"30\" height=\"30\" uk-svg><div class=\"rns-stream-info\">";
                    htmlBuild += `<p class="rns-stream-info__title">${el.title}</p>`;
                    htmlBuild += `<p class="rns-stream-info__speed">${el.bitrate} kbps</p>`;
                    htmlBuild += "</div></div>";
                    htmlBuild += `<button class="rns-stream-tile__btn" type="button" neo-player-stream data-neo-player-src="${el.src}"><img class="rns-stream-picked-play rns-stream-picked" src="assets/icons/play-btn.svg" width="40" height="40" uk-svg><img class="rns-stream-picked-stop rns-stream-not-picked" src="assets/icons/stop.svg" width="40" height="40" uk-svg></button>`;
                    htmlBuild += "</div>";
                    // eslint-disable-next-line no-extra-boolean-cast
                    if (el.default == "1") {
                        npObj.defaultStream = el.src;
                    }
                }
            }
            htmlBuild += "</div>";
            htmlBuild += `<div class="neoplayer-content"><div class="neoplayer-content-image"><img id="neoplayer-image" neoplayer-image src="${IMG_COVER_DEFAULT}"></div><div class="neoplayer-stream-text"><div class="neoplayer-content-desc"><span id="neoplayer-title" neoplayer-title class=""></span><br/><span id="neoplayer-subtitle" neoplayer-subtitle class=""></span></div><div class="neo-player-arrow neo-player-arrow-modal" uk-toggle="target: #offcanvas-push"><svg xmlns="http://www.w3.org/2000/svg" width="11.2" height="6.523" viewBox="0 0 11.2 6.523"><defs><style>.a{fill:#fff;stroke:#fff;stroke-width:0.2px;}</style></defs><path class="a" d="M5.5,103.411a.768.768,0,0,1-.545-.225l-4.73-4.73a.77.77,0,1,1,1.089-1.089L5.5,101.551l4.185-4.185a.77.77,0,0,1,1.089,1.089l-4.73,4.73A.768.768,0,0,1,5.5,103.411Z" transform="translate(0.099 -96.988)"/></svg></div></div></div></div>`;

            if (attributes.playStopBtn) {
                htmlBuild += "<div class=\"neoplayer-controls-box\">";
                htmlBuild += '<div class="neoplayer-time-control neoplayer-time-control-left"> <button neoplayer-rewind="10"> <span>10</span> <img class="rns-live-stream-box__img" src="assets/icons/left.svg" width="20" height="20" uk-svg> </button> </div>';
                htmlBuild += "<div id=\"neoplayer-prev\" neoplayer-prev><button><img class=\"rns-live-stream-box__img\" src=\"assets/icons/prev.svg\" width=\"20\" height=\"20\" uk-svg></button></div>";

                htmlBuild += "<div class=\"neopayer-btn-box\"><div id=\"neoplayer-play\" neoplayer-play class=\"neoplayer-play-btn\"><button><img class=\"rns-live-stream-box__img\" src=\"assets/icons/play-btn.svg\" width=\"60\" height=\"60\" uk-svg></button></div>";
                htmlBuild += "<div id=\"neoplayer-stop\" neoplayer-stop class=\"neoplayer-stop-btn\"><button><img class=\"rns-live-stream-box__img\" src=\"assets/icons/stop.svg\" width=\"60\" height=\"60\" uk-svg></button></div>";
                htmlBuild += "<div id=\"neoplayer-pause\" neoplayer-pause class=\"neoplayer-pause-btn\"><button><img class=\"rns-live-stream-box__img\" src=\"assets/icons/pause-btn.svg\" width=\"60\" height=\"60\" uk-svg></button></div></div>";

                htmlBuild += "<div id=\"neoplayer-next\" neoplayer-next><button><img class=\"rns-live-stream-box__img\" src=\"assets/icons/next.svg\" width=\"20\" height=\"20\" uk-svg></button></div>";
                htmlBuild += '<div class="neoplayer-time-control neoplayer-time-control-right"> <button neoplayer-fforward="30"> <span>30</span> <img class="rns-live-stream-box__img" src="assets/icons/right.svg" width="20" height="20" uk-svg> </button> </div>';

                htmlBuild += "</div>";
            }

            if (attributes.volumeBtn) {
                htmlBuild += "<div class=\"neoplayer-grupe-box\"><div class=\"neoplayer-trackbar-box\"><span id=\"neoplayer-trackbar-duration-start\" neoplayer-trackbar-duration-start class=\"duration\"></span><div id=\"neoplayer-trackbar\" neoplayer-trackbar class=\"neoplayer-trackbar\"><span data-neo-player-fsu=\"global\" neoplayer-trackbar-span class=\"trackbar\"><span class=\"neoplayer-dot\"> <span class=\"duration duration-left\" data-neo-player-trackbar-hint></span> </span></span></div><span id=\"neoplayer-trackbar-duration-finish\" neoplayer-trackbar-duration-finish class=\"duration\"></span></div>";
                htmlBuild += "<div id=\"neoplayer-volume-control\" class=\"neoplayer-volume-control\">";
                htmlBuild += `<span class="rns-mute-tooltip">${TEXT_MUTE_INFO}</span>`;
                htmlBuild += "<img id=\"neoplayer-volume-toggl-muted\" class=\"rns-live-stream-box__img neoplayer-volume-toggl-muted\" src=\"assets/icons/sound-mute.svg\" width=\"20\" height=\"20\" uk-svg><img id=\"neoplayer-volume-toggl\" class=\"rns-live-stream-box__img neoplayer-volume-toggl\" src=\"assets/icons/sound.svg\" width=\"20\" height=\"20\" uk-svg><div id=\"neoplayer-volume-arrow\" class=\"neo-player-arrow-info\"><img class=\"rns-live-stream-box__img\" src=\"assets/icons/angle-down.svg\" width=\"20\" height=\"20\" uk-svg></div><div id=\"neoplayer-volume-box\" class=\"neoplayer-volume-box\"><input type=\"range\" id=\"neoplayer-volume\" name=\"volume\" min=\"0\" max=\"1\" step=\"0.05\"><label for=\"volume\"></label><div id=\"neoplayer-mute\"><img class=\"neoplayer-volume-svg\" src=\"assets/icons/sound-mute.svg\" width=\"20\" height=\"20\" uk-svg></div></div></div></div>";
            }
            htmlBuild += "</div>";
            element.innerHTML = htmlBuild;
            $("[neoplayer-next]").css("visibility", "hidden");
            $("[neoplayer-prev]").css("visibility", "hidden");
            $("[neoplayer-trackbar]").css("visibility", "hidden");
            $("[neoplayer-play]").css("visibility", "visible");
            $(".neoplayer-time-control").css("visibility", "hidden");

            document.getElementById("neoplayer-volume-box").style.visibility = "hidden";

            document.getElementById("rns-stream").style.display = "block";
            document.getElementById("rns-live").style.display = "none";

            document.getElementById("neoplayer-open-dropdown").addEventListener("click", () => {
                if (document.getElementById("rns-stream-control").style.visibility === "visible") {
                    document.getElementById("rns-stream-control").style.visibility = "hidden";
                    document.getElementById("rns-stream-control").classList.remove("rns-stream-control-opened");
                } else {
                    document.getElementById("rns-stream-control").style.visibility = "visible";
                    document.getElementById("rns-stream-control").classList.add("rns-stream-control-opened");
                }
            });
            if (attributes.playStopBtn) {
                $(document).on("click", "[neoplayer-play]", (e) => {
                    const $el = $(e.currentTarget);
                    if (npObj.jingleActive) return false;
                    if (npObj.firstPlay) {
                        if (typeof $el.data('neo-player-src') === "undefined") {
                            npObj.setSource(npObj.defaultStream, false);
                            npObj.firstPlay = false;
                        }
                    } else {
                        npObj.play();
                    }
                });
                $(document).on("click", "[neoplayer-stop]", () => {
                    if (npObj.jingleActive) return false;
                    npObj.stop();
                });
                $(document).on("click", "[neoplayer-pause]", () => {
                    if (npObj.jingleActive) return false;
                    npObj.stop();
                });
            }

            if (attributes.volumeBtn) {
                addListenerMulti(document.getElementById("neoplayer-volume"), "click change input", (e) => {
                    npObj.setVolume(e.target.value);

                    updateRangeEl(e.target);
                });
                document.getElementById("neoplayer-volume-control").addEventListener("click", (e) => {
                    if (["neoplayer-volume", "neoplayer-volume-box"].indexOf(e.target.id) !== -1) return;
                    if (document.getElementById("neoplayer-volume-box").style.visibility === "hidden") {
                        document.getElementById("neoplayer-volume-box").style.visibility = "visible";
                        document.getElementById("neoplayer-volume-control").classList.add("neoplayer-volume-box-opened");
                    } else {
                        document.getElementById("neoplayer-volume-box").style.visibility = "hidden";
                        document.getElementById("neoplayer-volume-control").classList.remove("neoplayer-volume-box-opened");
                    }
                });
                document.getElementById("neoplayer-mute").addEventListener("click", () => {
                    if (npObj.audio.volume > 0) {
                        saveLSvalue('unmuteVolume', npObj.audio.volume);
                        document.getElementById("neoplayer-volume").value = 0;
                        npObj.setVolume(0);
                        updateRangeEl(document.getElementById("neoplayer-volume"));
                    } else {
                        let set = getLSvalue('unmuteVolume', 0.5);
                        document.getElementById("neoplayer-volume").value = set;
                        npObj.setVolume(set);
                        updateRangeEl(document.getElementById("neoplayer-volume"));
                    }
                });
            }

            $(document).on("mousedown touchstart", "[neoplayer-trackbar]", (e) => {
                npObj.trackBarIsSeeking = true;
                npObj.trackBarIsSeekingPaused = npObj.audio.paused;
                $('[data-neo-player-trackbar-hint]').css('visibility', 'visible');
                // npObj.audio.pause();
            });

            $(document).on("mousemove touchmove", "[neoplayer-trackbar]", (e) => {
                if (npObj.trackBarIsSeeking) {
                    const bounding = e.target.getBoundingClientRect();
                    let position = 0;
                    if (e.clientX != null) {
                        position = e.clientX - bounding.left;
                    } else {
                        position = e.originalEvent.changedTouches[0].pageX - bounding.left;
                    }
                    const seek = position / bounding.width;
                    const max = npObj.audio.duration;
                    let goToSeek = max * seek;
                    // npObj.audio.currentTime = goToSeek;
                    let percent = (goToSeek / npObj.audio.duration) * 100;
                    if (percent > 100) {
                        percent = 100;
                        goToSeek = max;
                    }
                    if (percent < 0) {
                        percent = 0;
                        goToSeek = 0;
                    }
                    $("[neoplayer-trackbar-span]").css("width", `${percent}%`);
                    $(".neoplayer-trackbar-box.podcast-player").each(function () {
                        const $mainEl = $(this).find("[neoplayer-podcast-trackbar-span]");
                        if ($mainEl.data("neo-player-fsu") === MD5(npObj.audio.src) || $mainEl.data("neo-player-fsu") == 'global') {
                            $(this).find("[neoplayer-podcast-trackbar-span]").css("width", `${percent}%`);
                        }
                    });
                    $(".neoplayer-trackbar-box").each(function () {
                        const $mainEl = $(this).find("[neoplayer-trackbar-span]");
                        if ($mainEl.data("neo-player-fsu") === MD5(npObj.audio.src) || $mainEl.data("neo-player-fsu") == 'global') {
                            $(this).find("[neoplayer-trackbar-span]").css("width", `${percent}%`);
                        }
                    });
                    $('[data-neo-player-trackbar-hint]').html(`${formatTime(goToSeek)}`);
                    if ((goToSeek / max) > 0.5) {
                        $('[data-neo-player-trackbar-hint]').removeClass('duration-left');
                        $('[data-neo-player-trackbar-hint]').addClass('duration-right');
                    } else {
                        $('[data-neo-player-trackbar-hint]').addClass('duration-left');
                        $('[data-neo-player-trackbar-hint]').removeClass('duration-right');
                    }
                }
            });

            $(document).on("mouseup touchend", "body", (e) => {
                if (npObj.trackBarIsSeeking) {
                    const bounding = e.target.getBoundingClientRect();
                    let position = 0;
                    if (e.clientX != null) {
                        position = e.clientX - bounding.left;
                    } else {
                        position = e.originalEvent.changedTouches[0].pageX - bounding.left;
                    }
                    const seek = position / bounding.width;
                    const max = npObj.audio.duration;
                    const goToSeek = max * seek;
                    npObj.audio.currentTime = goToSeek;
                    npObj.trackBarIsSeeking = false;
                    $('[data-neo-player-trackbar-hint]').css('visibility', 'hidden');
                    if (!npObj.trackBarIsSeekingPaused) {
                        npObj.audio.play();
                    }
                }
            });

            $(document).on("click", "[data-neo-player-seekto]", (e) => {
                if (!npObj.audio.paused) {
                    if ($(e.currentTarget).data("neo-player-fsu") === MD5(npObj.audio.src)) {
                        const goToSeek = $(e.currentTarget).data("neo-player-seekto");
                        if (npObj.audio.duration >= goToSeek) {
                            npObj.audio.currentTime = goToSeek;
                            npObj.audio.play();
                        } else if ($("#warn-no-access").length > 0) {
                            UIkit.modal("#warn-no-access").show();
                        }
                    } else {
                        npObj.stop();
                        const goToSeek = $(e.currentTarget).data("neo-player-seekto");
                        npObj.seekAfterPlay = goToSeek;
                        $('[neoplayer-podcast-main-play]').trigger('click');
                    }
                } else {
                    const goToSeek = $(e.currentTarget).data("neo-player-seekto");
                    npObj.seekAfterPlay = goToSeek;

                    $('[neoplayer-podcast-main-play]').trigger('click');
                }
            });

            $(document).on("click", "[neoplayer-rewind]", function (e) {
                const value = $(this).attr('neoplayer-rewind');
                npObj.audio.currentTime = npObj.audio.currentTime - parseInt(value);
            });

            $(document).on("click", "[neoplayer-fforward]", function (e) {
                const value = $(this).attr('neoplayer-fforward');
                npObj.audio.currentTime = npObj.audio.currentTime + parseInt(value);
            });

            $(document).on("click", "[neo-player]", (e) => {
                if (npObj.jingleActive) return false;
                const $e = $(e.currentTarget);
                const src = $e.data("neo-player-src");
                const part = $e.data("neo-player-part");
                const sct = $e.data("neo-player-sct");
                const title = $e.data("neo-player-title");
                const subTitle = $e.data("neo-player-subtitle");
                const img = $e.data("neo-player-img");
                const list = $e.data("neo-player-list");
                const cursor = $e.data("neo-player-list-cursor");
                const jingleIntro = $e.data("neo-player-jingle-intro");
                npObj.jingleOutro = $e.data("neo-player-jingle-outro");
                npObj.isDemoPodcast = $e.data("neo-player-additional");
                const sourceSum = $e.data("neo-player-source-sum");
                npObj.sourceSum = null;
                npObj.sourceSum = sourceSum;
                if ($e.data('neo-player-seralized-info')) {
                    $('[neoplayer-podcast-trackbar-span]').data('neo-player-fsu', $e.data('neo-player-fsu'));
                    $('h1.rns-podcast-title').html($e.data('neo-player-seralized-info')[0]);
                    $('#player-content').html($e.data('neo-player-seralized-info')[1]);
                    $('#player-timestamps').html('');
                    if ($e.data('neo-player-seralized-info')[2].length > 0) {
                        $e.data('neo-player-seralized-info')[2].forEach(el => {
                            if (el.ts < 60) {
                                el.ts_human = new Date(el.ts * 1000).toISOString().substr(17, 2);
                            } else if (el.ts >= 60 && el.ts < 3600) {
                                el.ts_human = new Date(el.ts * 1000).toISOString().substr(14, 5);
                            } else {
                                el.ts_human = new Date(el.ts * 1000).toISOString().substr(11, 8);
                            }

                            $('#player-timestamps').append('<li class="rns-timestamp-element" id="player-timestamps"> <div class="rns-timestamp-text-box" data-neo-player-seekto="' + el.ts + '"> <div class="rns-timestamp-wrapper" data-neo-player-seekto="' + el.ts + '"> <div class="rns-timestamp-time" data-neo-player-seekto="' + el.ts + '"> <img class="rns-timestamp-img" src="/assets/icons/play-pause.svg" alt="" uk-svg data-neo-player-seekto="' + el.ts + '"> ' + el.ts_human + ' <\/div><div class="rns-timestamp-title" data-neo-player-seekto="' + el.ts + '">' + el.name + '<\/div><\/div></div></li>')
                        });
                    }
                }

                if (src !== npObj.audio.src) {
                    npObj.setSource(src, true, title, subTitle, img, list, cursor, jingleIntro);
                } else {
                    npObj.play();
                }

                if (sct) {
                    $("html, body").stop().animate({scrollTop: 0}, 500, "swing", () => {
                    });
                    $("[neoplayer-podcast-main-play]").parent().find("[neoplayer-stop]").css("visibility", "visible");
                    $("[neoplayer-podcast-main-play]").css("visibility", "hidden");
                }
            });

            $(document).on("click", "[neo-player-stream]", (e) => {
                const $e = $(e.currentTarget);
                const src = $e.data("neo-player-src");
                npObj.setSource(src, false);
            });

            $(document).on("click", "[neoplayer-next]", (e) => {
                npObj.next();
            });

            $(document).on("click", "[neoplayer-prev]", (e) => {
                npObj.prev();
            });


            npObj.setVolume(getLSvalue("volume", 0.5));
            updateRangeEl(document.getElementById("neoplayer-volume"));

            npObj.metadata.title = TEXT_DEFAULT_TITLE;
            npObj.metadata.subTitle = TEXT_DEFAULT_SUBTITLE;
            npObj.metadata.imageSrc = IMG_COVER_DEFAULT;

            npObj.updateInfoBar();
            npObj.audio.preload = "none";
            const defaultSrc = `${npObj.defaultStream}?trns=${(Math.random() + 1).toString(36).substring(7)}`;
            npObj.audio.setAttribute("src", defaultSrc);
            npObj.updateInterval = setInterval(npObj.updateInfoBar, 10000);

            npObj.audio.addEventListener("ended", (e) => {
                if (npObj.isDemoPodcast) {
                    const advertAudio = new Audio();
                    advertAudio.src = npObj.jingleOutro ? npObj.jingleOutro : SRC_POSTADVERT_AUDIO;
                    advertAudio.load();
                    advertAudio.volume = npObj.audio.volume;
                    advertAudio.addEventListener("canplaythrough", (event) => {
                        advertAudio.play();
                        npObj.jingleActive = true;
                    });
                    advertAudio.addEventListener("ended", (e) => {
                        delete (advertAudio);
                        npObj.jingleActive = false;
                        npObj.stop();
                    });
                } else {
                    switch (AFTER_PODCAST_ACTION) {
                        case "NEXT_EPISODE_ACTION":
                            npObj.next();
                            break;
                        case "BACK_TO_RADIO_ACTION":
                            npObj.stop();
                            npObj.setSource(defaultSrc, false);
                            npObj.updateInfoBar();
                            npObj.play();
                            break;
                        case "STOP_ACTION":
                            npObj.stop();
                            break;

                    }
                }
            });
        };

        npObj.setSource = function (src, isStatic = true, metaTitle = "", metaSubTitle = "", metaImage = "", list = [], cursor = 0, jingleIntro = '') {
            if (npObj.jingleActive) {
                return;
            }
            if (src == '-') {
                if ($("#warn-no-access").length > 0) {
                    UIkit.modal("#warn-no-access").show();
                }
                return;
            }
            if (npObj.audio.volume == 0) {
                window.showMutedTooltip();
                showMessage(["Rozpoczęto odtwarzanie, ale Player jest wyciszony"]);
                setTimeout(window.hideMutedTooltip, 3000);
            }
            $("[neoplayer-trackbar-span]").css("width", "0%");
            npObj.audio.pause();
            // console.log('Buffering state: Start');
            npObj.audio.preload = "";
            document.getElementById("rns-stream-control").style.visibility = "hidden";
            npObj.isStatic = isStatic;
            npObj.currentSourceGtmSend = false;
            if (isStatic) {
                npObj.metadata.title = metaTitle;
                npObj.metadata.subTitle = metaSubTitle;
                npObj.metadata.imageSrc = metaImage;
                $("[neoplayer-trackbar]").css("visibility", "visible");
                $(".neoplayer-time-control").css("visibility", "visible");
                $('#rns-mobile-stream-text').text("Włącz radio");
                $('img.rns-stream-picked-stop').addClass('rns-stream-not-picked');
                $('img.rns-stream-picked-play').removeClass('rns-stream-not-picked');
                let otherParts = list;
                if (Array.isArray(otherParts) && otherParts.length > 1) {
                    npObj.mainStatic = otherParts[0];
                    npObj.staticArray = otherParts;
                    npObj.currentStatic = cursor;
                    npObj.currentSrc = otherParts[cursor].src;
                    npObj.audio.setAttribute("src", otherParts[cursor].src);
                } else {
                    npObj.currentSrc = src;
                    npObj.mainStatic = [];
                    npObj.mainStatic.src = src;
                    npObj.staticArray = [];
                    npObj.currentStatic = false;
                    npObj.audio.setAttribute("src", src);
                }

                npObj.audio.addEventListener("loadeddata", () => {
                    const {duration} = npObj.audio;
                    npObj.metadata.duration = duration;
                    if (npObj.seekAfterPlay !== false) {
                        if (npObj.audio.duration >= npObj.seekAfterPlay) {
                            npObj.audio.currentTime = npObj.seekAfterPlay;
                        } else if ($("#warn-no-access").length > 0) {
                            UIkit.modal("#warn-no-access").show();
                        }
                        npObj.seekAfterPlay = false;
                    }
                    // console.log('Buffering state: FDATA');
                });

                npObj.audio.addEventListener("timeupdate", () => {
                    if (npObj.isStatic) {
                        const percent = (npObj.audio.currentTime / npObj.audio.duration) * 100;
                        if (!npObj.trackBarIsSeeking) {
                            $("[neoplayer-trackbar-span]").css("width", `${percent}%`);
                        }
                        $("[neoplayer-trackbar-duration-start]").html(`${formatTime(npObj.audio.currentTime)}`);
                        $("[neoplayer-trackbar-duration-finish]").html(`${formatTime(npObj.audio.duration)}`);
                        $(".neoplayer-trackbar-box.podcast-player").each(function () {
                            const $mainEl = $(this).find("[neoplayer-podcast-trackbar-span]");
                            if ($mainEl.data("neo-player-fsu") === MD5(npObj.audio.src) || $mainEl.data("neo-player-fsu") == 'global') {
                                $(this).css("visibility", "visible");
                                if (!npObj.trackBarIsSeeking) {
                                    $(this).find("[neoplayer-podcast-trackbar-span]").css("width", `${percent}%`);
                                }
                                $(this).find("[neoplayer-podcast-trackbar-duration-start]").html(`${formatTime(npObj.audio.currentTime)}`);
                                $(this).find("[neoplayer-podcast-trackbar-duration-finish]").html(`${formatTime(npObj.audio.duration)}`);
                            } else {
                                $(this).css("visibility", "hidden");
                            }
                        });
                    } else {
                        $("[neoplayer-trackbar]").css("visibility", "hidden");
                        $("[neoplayer-trackbar-duration-start]").html("");
                        $("[neoplayer-trackbar-duration-finish]").html("");
                        $(".neoplayer-time-control").css("visibility", "hidden");
                    }
                });
            } else {
                npObj.canPlayJingle = true;
                $("[neo-player-slider-play]").css("display", "none");
                $(".rns-stream-tile__btn").each(function () {
                    if ($(this).data('neo-player-src') == src) {
                        $(this).find('img.rns-stream-picked-play').addClass('rns-stream-not-picked');
                        $(this).find('img.rns-stream-picked-stop').removeClass('rns-stream-not-picked');
                    } else {
                        $(this).find('img.rns-stream-picked-stop').addClass('rns-stream-not-picked');
                        $(this).find('img.rns-stream-picked-play').addClass('rns-stream-picked');
                        $(this).find('img.rns-stream-picked-play').removeClass('rns-stream-not-picked');
                    }
                });
                src += `?trns=${(Math.random() + 1).toString(36).substring(7)}`;
                npObj.audio.setAttribute("src", src);
                npObj.lastStreamSrc = src;
                if (npObj.metadata.title === "") {
                    npObj.metadata.title = TEXT_DEFAULT_TITLE;
                    npObj.metadata.subTitle = TEXT_DEFAULT_SUBTITLE;
                    npObj.metadata.imageSrc = IMG_COVER_DEFAULT;
                }
                $("[neoplayer-trackbar]").css("visibility", "hidden");
                $(".neoplayer-time-control").css("visibility", "hidden");
                $("[neoplayer-trackbar-duration-start]").html("");
                $("[neoplayer-trackbar-duration-finish]").html("");
                $("[neoplayer-podcast-trackbar-duration-start]").html("");
                $("[neoplayer-podcast-trackbar-duration-finish]").html("");
                npObj.staticArray = [];
                npObj.currentStatic = false;
            }

            npObj.audio.addEventListener('canplaythrough', () => {
                // console.log('Buffering state: ENUGHT');
            });
            npObj.audio.addEventListener('suspend', () => {
                // console.log('Buffering state: MORE MORE');
            });

            if (isStatic && npObj.isDemoPodcast) {
                const advertAudio = new Audio();
                advertAudio.volume = npObj.audio.volume;
                advertAudio.src = jingleIntro ? jingleIntro : SRC_PREADVERT_AUDIO;
                advertAudio.load();
                advertAudio.addEventListener("canplaythrough", (event) => {
                    advertAudio.play();
                    npObj.jingleActive = true;
                });
                advertAudio.addEventListener("ended", (e) => {
                    delete (advertAudio);
                    npObj.jingleActive = false;
                    npObj.play();
                });
            } else {
                npObj.play();
            }
            document.getElementById("rns-stream-control").style.visibility = "hidden";
            npObj.togglePrevNextButtons();
            npObj.updateInfoBar();
        };

        npObj.pause = function () {
            npObj.audio.pause();
            if (!npObj.isStatic) {
                npObj.audio.preload = "none";
                npObj.audio.setAttribute("src", "data:audio/ogg;base64,0");
                npObj.audio.load();
                $('img.rns-stream-picked-stop').addClass('rns-stream-not-picked');
                $('img.rns-stream-picked-play').removeClass('rns-stream-not-picked');
            }
        };

        npObj.play = function () {
            if (npObj.jingleActive) {
                return;
            }
            if (npObj.isStatic) {
                $('#rns-mobile-stream-text').text("Włącz radio");
            } else {
                $('#rns-mobile-stream-text').text("Zmień jakość");
                npObj.canPlayJingle = false;
                if (npObj.adDisplayContainer) {
                    npObj.jingleActive = true;
                    npObj.loadAds();
                } else {
                    const jingle = npObj.getJingle();
                    if (jingle) {
                        const advertAudio = new Audio();
                        advertAudio.volume = npObj.audio.volume;
                        advertAudio.src = jingle.jingle_url;
                        advertAudio.load();

                        if (jingle.title) {
                            npObj.metadata.title = jingle.title;
                            npObj.metadata.subTitle = '';
                            npObj.metadata.imageSrc = '';
                        }

                        $("[neoplayer-title]").html(npObj.metadata.title);
                        advertAudio.addEventListener("canplaythrough", (event) => {
                            advertAudio.play().catch((err) => {
                                console.error('Jingle play error', err);
                                npObj.jingleActive = false;
                            });
                            npObj.jingleActive = true;
                        });
                        advertAudio.addEventListener("error", (event) => {
                            npObj.jingleActive = false;
                            npObj.updateInfoBar();
                            npObj.playAudio();
                        });
                        advertAudio.addEventListener("ended", (e) => {
                            npObj.jingleActive = false;
                            npObj.updateInfoBar();
                            npObj.playAudio();
                        });
                        return;
                    }
                }
                return;
            }
            npObj.playAudio();
        };

        npObj.playAudio = function () {
            if (npObj.audio.src === "data:audio/ogg;base64,0") {
                npObj.isDemoPodcast = false;
                if (npObj.lastStreamSrc !== '') {
                    const defaultSrc = `${npObj.lastStreamSrc}?trns=${(Math.random() + 1).toString(36).substring(7)}`;
                    npObj.audio.setAttribute("src", defaultSrc);
                } else {
                    const defaultSrc = `${npObj.defaultStream}?trns=${(Math.random() + 1).toString(36).substring(7)}`;
                    npObj.audio.setAttribute("src", defaultSrc);
                }
                npObj.audio.load();
                npObj.audio.preload = "auto";
                $("[neoplayer-play]").css("visibility", "hidden");
                $("[neoplayer-stop]").css("visibility", "visible");

                setTimeout(() => {
                    npObj.audio.play();
                }, 1200);
            } else {
                $("[neoplayer-play]").css("visibility", "hidden");
                if (npObj.isStatic) {
                    $("[neoplayer-pause]").css("visibility", "visible");
                } else {
                    $("[neoplayer-stop]").css("visibility", "visible");
                }
                npObj.audio.play();
            }
            let decodedURI = decodeURI(npObj.audio.src);

            const otherPlayers = $(`[data-neo-player-src][data-neo-player-src!="${decodedURI}"]`);
            const otherPlayersParent = otherPlayers.parent();
            const otherPlayersPlayBtn = otherPlayersParent.find("[neo-player-custom-play]");
            const otherPlayersStopBtn = otherPlayersParent.find("[neo-player-custom-stop]");

            otherPlayersPlayBtn.css("visibility", "visible");
            otherPlayersPlayBtn.css("display", "flex");
            otherPlayersStopBtn.css("visibility", "hidden");
            otherPlayersStopBtn.css("display", "none");

            const currentPlayer = $(`[data-neo-player-src][data-neo-player-src="${decodedURI}"]`);
            const currentPlayerParent = currentPlayer.parent();
            const currentPlayerPlayBtn = currentPlayerParent.find("[neo-player-custom-play]");
            const currentPlayerStopBtn = currentPlayerParent.find("[neo-player-custom-stop]");
            const currentPlayerPauseBtn = currentPlayerParent.find("[neo-player-custom-pause]");


            currentPlayerPlayBtn.css("visibility", "hidden");
            currentPlayerPlayBtn.css("display", "none");
            if (npObj.isStatic) {
                currentPlayerPauseBtn.css("visibility", "visible");
                currentPlayerPauseBtn.css("display", "flex");
            } else {
                currentPlayerStopBtn.css("visibility", "visible");
                currentPlayerStopBtn.css("display", "flex");
            }

            $("#rns-stream-control").css('visibility', "hidden");
            $("#rns-stream-control").removeClass("rns-stream-control-mobile-opened");
            $("#rns-stream-control-mobile").css('visibility', "hidden");
            $("#rns-stream-control-mobile").removeClass("rns-stream-control-mobile-opened");

            $("[neo-player-custom-play]").each(function () {
                if (decodedURI === $(this).data("neo-player-src")) {
                    $(this).parent().find("[neo-player-custom-stop]").css("visibility", "visible");
                    $(this).parent().find("[neo-player-custom-stop]").css("display", "flex");


                    $(this).css("visibility", "hidden");
                    $(this).css("display", "none");
                }
            });

            $("[neoplayer-podcast-main-play]").each(function () {
                if ($(this).data("neo-player-fsu") === MD5(npObj.audio.src)) {
                    $(this).parent().find("[neoplayer-pause]").css("visibility", "visible");
                    $(this).css("visibility", "hidden");
                } else {
                    $(this).css("visibility", "visible");
                    $(this).parent().find("[neoplayer-pause]").css("visibility", "hidden");
                }
            });
            npObj.firstPlay = false;
            navigator.mediaSession.playbackState = 'playing';

            if(npObj.sourceSum !== null && npObj.currentSourceGtmSend == false) {
                npObj.gtmEvent = setTimeout(() => {
                    dataLayer.push({
                    'event': 'podcast_play',
                    'podcast_id': npObj.sourceSum,
                    'podcast_title': npObj.metadata.title.replace(/(<([^>]+)>)/gi, ""),
                    'user_type': npObj.usingUser
                    });
                    console.info("GTM EVENT FIRED");
                    console.info("U: " + npObj.usingUser + ", PT: " + npObj.metadata.title.replace(/(<([^>]+)>)/gi, "") + " PID:" + npObj.sourceSum);
                    npObj.currentSourceGtmSend = true;
                }, GTM_EVENT_TO);
            }
        }

        npObj.setVolume = function (vol) {
            vol = parseFloat(vol);
            vol = (vol > 1) ? 1 : vol;
            vol = (vol < 0) ? 0 : vol;
            npObj.audio.volume = vol;
            document.getElementById("neoplayer-volume").value = vol;
            saveLSvalue("volume", vol);
        };

        npObj.stop = function () {
            $("[neoplayer-play]").css("visibility", "visible");
            $("[neoplayer-stop]").css("visibility", "hidden");
            $("[neoplayer-pause]").css("visibility", "hidden");

            let decodedURI = decodeURI(npObj.audio.src);

            const othersPlayers = $(`[data-neo-player-src][data-neo-player-src!="${decodedURI}"]`);
            const othersPlayersParent = othersPlayers.parent();
            const othersPlayersStopBtn = othersPlayersParent.find("[neo-player-custom-stop]");

            othersPlayersStopBtn.css("visibility", "hidden");
            othersPlayersStopBtn.css("display", "none");

            const currentPlayer = $(`[data-neo-player-src][data-neo-player-src="${decodedURI}"]`);
            const currentPlayerParent = currentPlayer.parent();
            const currentPlayerStopBtn = currentPlayerParent.find("[neo-player-custom-stop]");
            const currentPlayerPlayBtn = currentPlayerParent.find("[neo-player-custom-play]");

            currentPlayerStopBtn.css("visibility", "hidden");
            currentPlayerPlayBtn.css("visibility", "visible");

            currentPlayerStopBtn.css("display", "none");
            currentPlayerPlayBtn.css("display", "flex");

            clearTimeout(npObj.gtmEvent);
            npObj.pause();
        };

        npObj.updateInfoBar = async function () {
            if (!vis()) return;
            if (npObj.jingleActive) return;
            if (!npObj.isStatic) {
                if (npObj.audio.paused === false) {
                    $("[neo-player-slider-play]").css("display", "none");
                } else {
                    $("[neo-player-slider-play]").css("display", "flex");
                }
                $("[neoplayer-title]").html(npObj.metadata.title);
                $.get(API_RADIO_STAT + "?tsapi=" + Date.now())
                    .then((response) => {
                        if (response.status === false) return;
                        npObj.metadata.subTitle = response.data.title;
                        npObj.metadata.title = response.data.artist;
                        $("[neoplayer-title]").html(npObj.metadata.title);
                        $("[neoplayer-subtitle]").html(npObj.metadata.subTitle);
                        if (response.data.hasOwnProperty('schedule_img')) {
                            $("[neoplayer-image]").attr("src", response.data.schedule_img);
                        } else {
                            if (npObj.cachedThumbs[npObj.metadata.subTitle] === undefined) {
                                $.ajax({
                                    type: "GET",
                                    cache: true,
                                    url: `https://itunes.apple.com/search?term=${npObj.metadata.title} ${npObj.metadata.subTitle}`,
                                    async: true,
                                    dataType: "jsonp",
                                    success(json) {
                                        if (typeof (json) !== "object") {
                                            json = JSON.parse(json);
                                        }
                                        if (json.resultCount > 0) {
                                            const thumb = json.results[0].artworkUrl100.split("100x100bb.jpg").join("1000x1000bb.jpg");
                                            npObj.cachedThumbs[npObj.metadata.subTitle] = thumb;
                                            $("[neoplayer-image]").attr("src", thumb);
                                        } else {
                                            const thumb = "https://nowyswiat.online/wp-content/uploads/2020/09/fala-690x690.png";
                                            npObj.cachedThumbs[npObj.metadata.subTitle] = thumb;
                                            $("[neoplayer-image]").attr("src", thumb);
                                        }
                                    },
                                });
                            } else {
                                $("[neoplayer-image]").attr("src", npObj.cachedThumbs[npObj.metadata.subTitle]);
                            }
                        }
                    });
            } else {
                $("[neoplayer-title]").html(npObj.metadata.title);
                $("[neoplayer-subtitle]").html(npObj.metadata.subTitle);
                $("[neoplayer-image]").attr("src", npObj.metadata.imageSrc);
                $("[neo-player-slider-play]").css("display", "flex");
            }
            if ("mediaSession" in navigator) {
                navigator.mediaSession.metadata = new MediaMetadata({
                    title: npObj.metadata.title.replace(/(<([^>]+)>)/gi, ""),
                    artist: npObj.metadata.subTitle.replace(/(<([^>]+)>)/gi, ""),
                    artwork: [
                        {src: $("[neoplayer-image]").attr("src"), sizes: "96x96", type: "image/png"},
                        {src: $("[neoplayer-image]").attr("src"), sizes: "128x128", type: "image/png"},
                        {src: $("[neoplayer-image]").attr("src"), sizes: "192x192", type: "image/png"},
                        {src: $("[neoplayer-image]").attr("src"), sizes: "256x256", type: "image/png"},
                        {src: $("[neoplayer-image]").attr("src"), sizes: "384x384", type: "image/png"},
                        {src: $("[neoplayer-image]").attr("src"), sizes: "512x512", type: "image/png"},
                    ],
                });
                navigator.mediaSession.setActionHandler('seekbackward', function (e) {
                    const skipTime = e.seekOffset || defaultSkipTime;
                    npObj.audio.currentTime = Math.max(audio.currentTime - skipTime, 0);
                });
                navigator.mediaSession.setActionHandler('seekforward', function (e) {
                    const skipTime = e.seekOffset || defaultSkipTime;
                    npObj.audio.currentTime = Math.min(audio.currentTime + skipTime, audio.duration);
                });
                navigator.mediaSession.setActionHandler('stop', function () {
                    npObj.stop();
                    navigator.mediaSession.playbackState = 'paused';
                });
                navigator.mediaSession.setActionHandler('pause', function () {
                    npObj.stop();
                    navigator.mediaSession.playbackState = 'paused';
                });
                navigator.mediaSession.setActionHandler('play', function () {
                    npObj.play();
                    navigator.mediaSession.playbackState = 'playing';
                });
            }
        };

        npObj.isNextAvailable = function () {
            if (this.staticArray.length > 0) {
                if (this.currentStatic === this.staticArray.length - 1) {
                    return false;
                }
                return true;
            }
            return false;
        };

        npObj.isPrevAvailable = function () {
            if (this.staticArray.length > 0) {
                if (this.currentStatic !== 0) {
                    return true;
                }
                return false;
            }
            return false;
        };

        npObj.next = function () {
            if (this.staticArray.length < 2) {
                npObj.stop();
                return;
            }

            if (npObj.isNextAvailable()) {
                npObj.audio.pause();
                npObj.audio.preload = "";
                npObj.currentStatic = npObj.currentStatic + 1;
                npObj.currentSourceGtmSend = false;
                if (typeof npObj.staticArray[npObj.currentStatic] !== "undefined") {
                    npObj.audio.setAttribute("src", npObj.staticArray[npObj.currentStatic].src);
                    npObj.currentSrc = npObj.staticArray[npObj.currentStatic].src;
                    npObj.metadata.title = npObj.staticArray[npObj.currentStatic].name;
                    npObj.audio.addEventListener("loadeddata", () => {
                        const {duration} = npObj.audio;
                        npObj.metadata.duration = duration;
                    });
                    npObj.metadata.title = npObj.staticArray[npObj.currentStatic].name;
                    $('h1.rns-podcast-title').text(npObj.staticArray[npObj.currentStatic].name);
                    npObj.play();
                    npObj.togglePrevNextButtons();
                    $(".neoplayer-trackbar-box.podcast-player").each(function () {
                        const $mainEl = $(this).find("[neoplayer-podcast-trackbar-span]");
                        $mainEl.data("neo-player-fsu", MD5(npObj.audio.src));
                    });
                    $("[neo-player-custom-play]").each(function () {
                        if (npObj.audio.src === $(this).data("neo-player-src")) {
                            $(this).parent().find("[neo-player-custom-stop]").css("visibility", "visible");
                            $(this).parent().find("[neo-player-custom-stop]").css("display", "flex");
                            $(this).css("visibility", "hidden");
                            $(this).css("display", "none");
                        }
                    });
                    $("[neoplayer-podcast-main-play]").data('neo-player-fsu', MD5(npObj.audio.src));
                    $("[neoplayer-podcast-main-play]").data('neo-player-src', npObj.audio.src);
                }
                npObj.spaHibCtrlCallback();
                npObj.updateInfoBar();
            } else {
                npObj.stop();
            }
        };

        npObj.prev = function () {
            if (this.staticArray.length < 2) return;

            if (npObj.isPrevAvailable()) {
                npObj.audio.pause();
                npObj.audio.preload = "";
                npObj.currentStatic = npObj.currentStatic - 1;
                if (typeof npObj.staticArray[npObj.currentStatic] !== "undefined") {
                    npObj.audio.setAttribute("src", npObj.staticArray[npObj.currentStatic].src);
                    npObj.currentSrc = npObj.staticArray[npObj.currentStatic].src;
                    npObj.metadata.title = npObj.staticArray[npObj.currentStatic].name;
                    npObj.audio.addEventListener("loadeddata", () => {
                        const {duration} = npObj.audio;
                        npObj.metadata.duration = duration;
                    });
                    npObj.play();
                    npObj.togglePrevNextButtons();
                    $('h1.rns-podcast-title').text(npObj.staticArray[npObj.currentStatic].name);
                    $(".neoplayer-trackbar-box.podcast-player").each(function () {
                        const $mainEl = $(this).find("[neoplayer-podcast-trackbar-span]");
                        $mainEl.data("neo-player-fsu", MD5(npObj.audio.src))
                    });
                    $("[neo-player-custom-play]").each(function () {
                        if (npObj.audio.src === $(this).data("neo-player-src")) {
                            $(this).parent().find("[neo-player-custom-stop]").css("visibility", "visible");
                            $(this).parent().find("[neo-player-custom-stop]").css("display", "flex");
                            $(this).css("visibility", "hidden");
                            $(this).css("display", "none");
                        }
                    });
                    $("[neoplayer-podcast-main-play]").data('neo-player-fsu', MD5(npObj.audio.src));
                    $("[neoplayer-podcast-main-play]").data('neo-player-src', npObj.audio.src);
                }
                npObj.metadata.title = npObj.staticArray[npObj.currentStatic].name;
                $('h1.rns-podcast-title').text(npObj.staticArray[npObj.currentStatic].name);
                npObj.spaHibCtrlCallback();
                npObj.updateInfoBar();
            }
        };

        npObj.togglePrevNextButtons = function () {
            if (npObj.isPrevAvailable()) {
                // document.getElementById("neoplayer-prev").style.visibility = "visible";
                $('[neoplayer-prev]').css('visibility', 'visible');
            } else {
                $('[neoplayer-prev]').css('visibility', 'hidden');
            }
            if (npObj.isNextAvailable()) {
                $('[neoplayer-next]').css('visibility', 'visible');
            } else {
                $('[neoplayer-next]').css('visibility', 'hidden');
            }
        };

        npObj.spaHibCtrlCallback = function () {
            $("[neoplayer-next]").css("visibility", "hidden");
            $("[neoplayer-prev]").css("visibility", "hidden");
            npObj.togglePrevNextButtons();

            if (npObj.audio.paused) {
                $("[neoplayer-play]").each(function () {
                    $(this).css("visibility", "visible");
                });
                $("[neo-player-custom-play]").each(function () {
                    $(this).css("visibility", "visible");
                });
            } else {
                $("[neo-player-custom-play]").each(function () {
                    if (npObj.audio.src === $(this).data("neo-player-src")) {
                        $(this).parent().find("[neo-player-custom-stop]").css("visibility", "visible");
                        $(this).parent().find("[neo-player-custom-stop]").css("display", "flex");
                        $(this).css("visibility", "hidden");
                        $(this).css("display", "none");
                    }
                });
                $("[neoplayer-podcast-main-play]").each(function () {
                    if (typeof $(this).data("neo-player-fsu") !== "undefined") {
                        if ($(this).data("neo-player-fsu") === MD5(npObj.audio.src) || (npObj.mainStatic !== false && $(this).data("neo-player-fsu") === MD5(npObj.mainStatic.src))) {
                            $(this).parent().find("[neoplayer-pause]").css("visibility", "visible");
                            $(this).css("visibility", "hidden");
                            npObj.togglePrevNextButtons();
                            $("[neoplayer-podcast-main-play]").data('neo-player-fsu', MD5(npObj.audio.src));
                            $("[neoplayer-podcast-main-play]").data('neo-player-src', npObj.audio.src);
                        } else {
                            $(this).css("visibility", "visible");
                            npObj.togglePrevNextButtons();
                            $(this).parent().parent().find("[neoplayer-prev]").css("visibility", "hidden");
                            $(this).parent().parent().find("[neoplayer-next]").css("visibility", "hidden");
                        }
                    }
                });
            }
            npObj.recgonizePodcastPage();
        };
        npObj.recgonizePodcastPage = function () {
            if ($('#rns-podcast-player').length == 1 && npObj.currentSrc !== null) {
                let $e = $('[data-neo-player-sct][data-neo-player-fsu="' + MD5(npObj.currentSrc) + '"]');
                if ($e.data('neo-player-seralized-info')) {
                    $('[neoplayer-podcast-trackbar-span]').data('neo-player-fsu', $e.data('neo-player-fsu'));
                    $('h1.rns-podcast-title').html($e.data('neo-player-seralized-info')[0]);
                    $('#player-content').html($e.data('neo-player-seralized-info')[1]);
                    $('#player-timestamps').html('');
                    if ($e.data('neo-player-seralized-info')[2].length > 0) {
                        $e.data('neo-player-seralized-info')[2].forEach(el => {
                            if (el.ts < 60) {
                                el.ts_human = new Date(el.ts * 1000).toISOString().substr(17, 2);
                            } else if (el.ts >= 60 && el.ts < 3600) {
                                el.ts_human = new Date(el.ts * 1000).toISOString().substr(14, 5);
                            } else {
                                el.ts_human = new Date(el.ts * 1000).toISOString().substr(11, 8);
                            }

                            $('#player-timestamps').append('<li class="rns-timestamp-element" id="player-timestamps"> <div class="rns-timestamp-text-box" data-neo-player-seekto="' + el.ts + '"> <div class="rns-timestamp-wrapper" data-neo-player-seekto="' + el.ts + '"> <div class="rns-timestamp-time" data-neo-player-seekto="' + el.ts + '"> <img class="rns-timestamp-img" src="/assets/icons/play-pause.svg" alt="" uk-svg data-neo-player-seekto="' + el.ts + '"> ' + el.ts_human + ' <\/div><div class="rns-timestamp-title" data-neo-player-seekto="' + el.ts + '">' + el.name + '<\/div><\/div></div></li>')
                        });
                    }
                }
            }
        };

        npObj.reloadStreamList = function (list) {
            if (list.length > 0) {
                let htmlBuild = "";
                for (let i = 0; i < list.length; i += 1) {
                    const el = list[i];
                    htmlBuild += "<div class=\"rns-stream-tile\"><div class=\"rns-stream-info-box\"> <img class=\"rns-live-stream-img\" src=\"assets/icons/live.svg\" width=\"30\" height=\"30\" uk-svg><div class=\"rns-stream-info\">";
                    htmlBuild += `<p class="rns-stream-info__title">${el.title}</p>`;
                    htmlBuild += `<p class="rns-stream-info__speed">${el.bitrate} kbps</p>`;
                    htmlBuild += "</div></div>";
                    htmlBuild += `<button class="rns-stream-tile__btn" type="button" neo-player-stream data-neo-player-src="${el.src}"><img src="assets/icons/play-btn.svg" width="40" height="40" uk-svg></button>`;
                    htmlBuild += "</div>";
                }
                $("#rns-stream-control").html(htmlBuild);
            }
        };

        npObj.getJingle = function () {
            const request = new XMLHttpRequest();
            request.open('GET', API_JINGLE, false);
            request.send(null);
            if (request.response.length > 0) {
                if (typeof gtag === 'function') {
                    gtag('event', 'api_jingle', request.response.replace(/\\/gi, ''));
                }
                return JSON.parse(request.response);
            }
            return request.response;
        };

        $(document).on("click", "[neo-player-custom-stop]", () => {
            npObj.stop();
        });
        return npObj;
    }

    if (typeof (window.neoPlayer) === "undefined") {
        window.neoPlayer = neoPlayer();
    }
}(window));
